import { EMaritalStatus } from '../enums/marital-status.enum';

export const MaritalStatusOptions = [
    { value: EMaritalStatus.SOLTEIRO, label: 'Solteiro(a)' },
    { value: EMaritalStatus.CASADO, label: 'Casado(a)' },
    { value: EMaritalStatus.DIVORCIADO, label: 'Divorciado(a)' },
    { value: EMaritalStatus.VIUVO, label: 'Viúvo(a)' },
    { value: EMaritalStatus.UNIAO_ESTAVEL, label: 'União estável' },
    { value: EMaritalStatus.OUTRO, label: 'Outro' },
];
